<template>
  <div v-if="!isNotAuthLink || isUnauthorizedRoute">
    <router-view />
  </div>
  <div
    v-else
    id="app"
    :class="[isMobile ? 'app-mobile' : '', { 'font-mulish': isDriverRole }]"
    :style="isHeader ? '' : 'padding: 0'"
  >
    <come-back-to-admin v-if="isComeBackToAdmin" />
    <come-back-to-ceo v-if="isComeBackToCeo" />
    <template v-if="isNoCurrent">
      <CheckOrganization
        v-if="!isDriverRole"
        @addedOrganization="goToProfile"
      />
      <auth v-else :page="3" />
    </template>
    <template v-else>
      <div v-if="isHeader">
        <Header v-if="!isMobile" :hide="hideMenu" />
        <header-mobile-new
          v-else-if="!isDriverRole"
          :hide="hideMenu"
          :user-info="userInfo"
        />
        <driver-bottom-menu v-else />
      </div>
      <router-view />
    </template>
  </div>
</template>

<script>
import { GET_PROFILE } from '@/store/actions/userprofile'
import { mapGetters } from 'vuex'
import Auth from '@/views/Auth/Auth'
import CheckOrganization from '@/components/Forms/CheckOrganization'
import ComeBackToAdmin from '@/components/Header/components/ComeBackToAdmin/ComeBackToAdmin'
import ComeBackToCeo from '@/components/Header/components/ComeBackToCeo/ComeBackToCeo'
import DriverBottomMenu from '@/components/Drivers/DriverBottomMenu/DriverBottomMenu'
import Header from '@/components/Header/Header'
import HeaderMobileNew from '@/components/Header/HeaderMobileNew'

export default {
  name: 'App',
  components: {
    Auth,
    DriverBottomMenu,
    ComeBackToAdmin,
    ComeBackToCeo,
    HeaderMobileNew,
    Header,
    CheckOrganization,
  },
  data() {
    return {
      fetchInterval: null,
      visibleWelcomePage: true,
    }
  },
  computed: {
    ...mapGetters({ isAuth: 'auth/isAuth' }),
    isNotAuthLink() {
      return this.$route.name !== 'Login'
    },
    isUnauthorizedRoute() {
      const names = ['Intro', 'Terms', 'Privacy']

      return names.includes(this.$route.name)
    },
    isNoCurrent() {
      return this.isAuth && !this.userInfo.current
    },
    userType() {
      return this.userInfo.user_type
    },
    hideMenu() {
      let stat = this.statHaveObject()

      return !stat.allCompleate
    },
    isHeader() {
      const names = ['Intro', 'Login', 'Infographic', 'Terms', 'Privacy']

      return !names.includes(this.$route.name)
    },
    isComeBackToAdmin() {
      return this.userInfo.user_type !== 1 && Boolean(this.userInfo.id)
    },
    isComeBackToCeo() {
      return (
        this.userInfo.user_type !== 6 &&
        Boolean(localStorage.getItem('ceo-token'))
      )
    },
  },
  watch: {
    userType: {
      handler: 'fetchAdminData',
      immediate: true,
    },
    // $route: 'checkCarrierComplete',
  },
  created() {
    if (this.isHeader && !this.userInfo.current) {
      this.$store.dispatch(`userProfile/${GET_PROFILE}`)
    }

    // ////  костыль, вычищающий ранее сохраненные в ЛокалСторе варианты мест погрузки и выгрузки
    // ////  отрабатывает единоразово
    // //// в принципе, если январь 2026 года закончен - можно выпиливать
    const alreadyCleared = localStorage.getItem('force-clear-load-unload')

    if (!alreadyCleared) {
      localStorage.removeItem('vue_statefastlinkkladrLoad')
      localStorage.removeItem('vue_statefastlinkkladrUnLoad')
      localStorage.removeItem('vue_statefastlinkregionLoad')
      localStorage.removeItem('vue_statefastlinkregionUnLoad')

      localStorage.setItem('force-clear-load-unload', true)
    }
    // ////  конец костыля
  },
  beforeDestroy() {
    clearInterval(this.fetchInterval)
  },
  methods: {
    goToProfile() {
      this.$router.push({ path: '/user' })
    },
    handleApprovements() {
      this.$store.dispatch('approvements/fetchApprovements')
      this.fetchInterval = setInterval(() => {
        this.$store.dispatch('approvements/fetchApprovements')
      }, 60 * 1000)
    },
    fetchAdminData(value) {
      if (value === 1 && this.isHeader && !this.fetchInterval) {
        this.handleApprovements()
      }
    },
  },
}
</script>

<style lang="sass">
#app
  background-color: #F9F9F9
  margin: auto
  font-family: 'Rubik', sans-serif
  color: #1B1E24
  min-height: 100vh
  min-width: auto
  padding-bottom: 50px
  &.app-mobile
    background-color: #FFF
    max-width: 1024px
    padding-bottom: 0
  @media screen and (max-width: 600px)
    box-sizing: border-box
  .container
    max-width: 1440px
    margin: auto !important
    padding: 0 12px
    &.no-carrier-info
      text-align: center;
      background: orangered;
      padding: 10px
      color: white;
      font-weight: bold
      text-transform: uppercase;
      span
        border-bottom: 1px solid;
        cursor: pointer;
        margin-right: 10px;
  .slide-fade-enter-active
    transition: all .3s ease

  .slide-fade-leave-active
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0)

  .slide-fade-enter, .slide-fade-leave-to
    transform: translateX(10px)
    opacity: 0
  /* шрифт для нового интерфейса водителя  */
  &.font-mulish
    font-family: 'Mulish', sans-serif
a
  text-decoration: none

h2
  font-weight: normal
.pb-70
  padding-bottom: 70px
.pt-70
  padding-top: 70px
.p-20
  padding: 20px 0
.ta-l
  text-align: left
.ta-c
  text-align: center
.ta-r
  text-align: right
.tt-cap
  text-transform: capitalize
.tt-up
  text-transform: uppercase
.border-t
  border-top: 1px solid #DEE1E2
.el-table
  min-height: 100px
.d-none
  display: none !important
.df
  display: flex
.ai-c
  align-items: center
.df-c
  display: flex
  justify-content: center
.jc-sb
  justify-content: space-between
.fw-wrap
  flex-wrap: wrap
.fd-column
  flex-direction: column
.mb-10
  margin-bottom: 10px
.mt-10
  margin-top: 10px
.ml-10
  margin-left: 10px
.mr-10
  margin-right: 10px
.w-auto
  width: auto !important
.fs-14
  font-size: 14px
.cp
  cursor: pointer
.td-u
  text-decoration: underline
.redColor
  color: #ff0000
.my_container
  padding: 20px 30px

.top-header
  margin-bottom: 38px

.el-input__inner
  //height: 54px
  width: 100%
  font-family: "Rubik", Arial, sans-serif !important

.el-select
  width: 100%

.el-select,  .el-select-dropdown__list
  font-family: "Rubik", Arial, sans-serif !important
</style>
